module.exports = __webpack_public_path__ + "img/24.71bdd6ed.png";